import store from '../../store';

export default async function getPagesTree(parentId = null) {
	const where = {
		and: [
			{ route: { neq: null }},
		],
	};
	
	const pages = await store.model.Page.find({
		where,
		fields: ['id', 'title', 'route', 'parentId', 'order', 'navId'],
		order: 'order asc, id asc',
	});
	
	const rootPages = pages.filter(page => parentId ? page.parentId === parentId : !page.parentId);
	
	const pagesObj = Object.fromEntries(pages.map(page => [page.id, page]));
	
	const getFullRoute = page => {
		let route = page.route;
		if (page.parentId) {
			route = getFullRoute(pagesObj[page.parentId]) + route;
		}
		return route;
	};
	
	const getChildren = page => {
		page.__children = [];
		pages.forEach(p => {
			if (p.parentId === page.id) {
				getChildren(p);
				page.__children.push(p);
			}
		});
	};
	
	for (const page of pages) {
		page.__parent = page.parentId ? pagesObj[page.parentId] : undefined;
		page.__route = getFullRoute(page);
	}
	
	rootPages.forEach(getChildren);
	
	// console.log('rootPages', rootPages.map(p => ({ id: p.id, route: p.route, title: p.title })));
	// console.log('pagesObj', pagesObj);
	// console.log('pages', pages);
	
	return { pagesObj, tree: rootPages };
};
